import * as React from "react";
import { useEffect, useRef } from "react";
import { styled } from "../../stitches.config";

interface VeedmoPlayerProps {
    embed?: string;
    src?: string;
    mid?: string;
}

export default function VeedmoPlayer({
    embed = "Mamadu",
    src = "//bc.veedmo.com/v1/pl/e/68b05e576fb6fb5262da784a/929f6b79-ffac-4fe2-bb4b-d8b309c14e66",
    mid,
}: VeedmoPlayerProps) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current) return;

        containerRef.current.innerHTML = "";

        const script = document.createElement("script");

        const isValidMid = typeof mid === "string" && mid.startsWith("//");
        script.src = isValidMid ? mid! : src;

        script.async = true;
        script.setAttribute("data-embed", embed);

        containerRef.current.appendChild(script);

        return () => {
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }
        };
    }, [embed, src, mid]);

    return (
        <PlayerContainer>
            <div
                ref={containerRef}
                style={{
                    position: "absolute",
                    inset: 0,
                }}
            />
        </PlayerContainer>
    );
}

const PlayerContainer = styled("div", {
    position: "relative",
    width: "100%",
    paddingBottom: "56.25%",
});